module.exports = __webpack_public_path__ + "img/mddpaa.64ee246a.png";